import { render, staticRenderFns } from "./SFlag.vue?vue&type=template&id=4e7e3c8e&scoped=true"
import script from "./SFlag.vue?vue&type=script&lang=js"
export * from "./SFlag.vue?vue&type=script&lang=js"
import style0 from "./SFlag.vue?vue&type=style&index=0&id=4e7e3c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7e3c8e",
  null
  
)

export default component.exports